import { useStyleSheet } from '../../../hooks/useStyleSheet';

export const useStyles = () =>
  useStyleSheet(
    (theme) => ({
      container: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.secondary,

        '& > button:nth-of-type(2)': {
          marginRight: '0.1rem',
        },
      },
      button: {
        minWidth: 23,
        width: 23,
        padding: theme.spacing.secondary,

        '& > svg': {
          position: 'absolute',
        },
      },
    }),
    [],
  );
